import graphqlClient from 'Utils/graphql-client/graphqlClient';
import { paymentRedirectMutation } from 'Utils/graphql-query-helper/booking/payment-redirect/paymentRedirectQuery';
import { PAYMENT_ACTION } from 'Utils/payment/constants';
import {
  getCallbackURIFromProvider,
  getCallbackUrlSeller,
  getCancelCallbackURI,
  getIframeCallbackUrl,
} from 'Utils/payment/payment.utils';
import { PAYMENT_REDIRECT } from 'Utils/request/requestDictionary';
export const getPaymentRedirectMutation =
  ({
    proposal,
    appContext,
    params,
  }: {
    proposal: Proposal;
    appContext: AppContext;
    params?: any;
  }) =>
  ({
    amountToPay,
    donationAmount,
    browserInfo,
    isIframe,
    location,
    device,
    comments,
    paymentProviderId,
    shouldSkipPayment,
    paymentConditionId,
    token,
    callReference,
    contactID,
    billingDetails,
    customerId,
  }: PaymentRedirectMutationParams) => {
    const proposalId = proposal.id;
    const callbackUrl = getCallbackURIFromProvider(
      paymentProviderId,
      proposalId,
      appContext,
      location,
    );
    return graphqlClient
      .runNoCacheQuery(
        paymentRedirectMutation({
          action: PAYMENT_ACTION.PAYMENT_RESA,
          callbackUrl,
          bookingId: params?.bookingId,
          proposalId,
          cancelUrl: getCancelCallbackURI(appContext, location),
          iframeCallbackUrl: getIframeCallbackUrl(location),
          callbackUrlSeller: getCallbackUrlSeller(location),
          price: amountToPay,
          comments,
          currency: proposal.price.currency,
          shouldSkipPayment,
          donationAmount,
          browserInfo,
          isIframe,
          device,
          providerId: paymentProviderId,
          paymentConditionId,
          token,
          billingDetails,
          customerId,
          callReference,
          contactID,
          salesmanCode: appContext.cxoQueryParams?.salesman_code || appContext.cmta?.salesmanID,
          salesNetworkId: appContext.cxoQueryParams?.sales_network_id,
          cxoOpportunityGuid: appContext.cxoQueryParams?.opportunity_id,
        }),
        appContext,
        {
          requestName: PAYMENT_REDIRECT,
        },
      )
      .catch((error) => {
        throw error;
      });
  };
